// A local copy of the chain list for surfaces that only need to know which
// chains exist. Without it a log page paints every row as a link and takes it
// back a moment later.
//
// ⚠️ Not for the Screening report: that polls /health because it decides which
// checks may run, and a cached list would offer a chain the service cannot
// serve.
const STORAGE_KEY = 'baseline-chains'

// Bump when `normalizeBaselineChain`'s shape changes, so an older copy is
// discarded rather than half-read.
const VERSION = 1

// Long: the list is nearly static and every session revalidates. This only
// bounds a browser that has been away for weeks and cannot reach the service.
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export const readCachedBaselineChains = (now = Date.now()) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []

    const { version, savedAt, chains } = JSON.parse(raw)

    if (version !== VERSION || !Array.isArray(chains)) return []
    if (!savedAt || now - savedAt > MAX_AGE_MS) return []

    return chains
  } catch (error) {
    // Unreadable or denied: the caller fetches, as it did before this existed.
    return []
  }
}

export const writeCachedBaselineChains = (chains, now = Date.now()) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ version: VERSION, savedAt: now, chains }),
    )
  } catch (error) {
    // Private mode or full quota. Losing the cache costs one request.
  }
}
